import { render, staticRenderFns } from "./vue-qz-tray-status.vue?vue&type=template&id=5820b83e&scoped=true&"
import script from "./vue-qz-tray-status.vue?vue&type=script&lang=js&"
export * from "./vue-qz-tray-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820b83e",
  null
  
)

export default component.exports